"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const DEFAULT_LOCALE = "en-US";
const loadedLocaleData = {};
const ALLOWED_LOCALES = window.adobe_dc_sdk && window.adobe_dc_sdk.cache ? Object.keys(window.adobe_dc_sdk.cache.supportedLocales) : ["en-US"];
ALLOWED_LOCALES.forEach(loc => loadedLocaleData[loc] = require(`translations/${loc}.json`)); // eslint-disable-line

const getFinalLocale = inLocale => {
  if (!inLocale || inLocale.indexOf("-") < 0) {
    return DEFAULT_LOCALE;
  }
  const localeMap = inLocale.split("-");
  const normalizedLocale = `${localeMap[0].toLowerCase()}-${localeMap[1].toUpperCase()}`;
  if (ALLOWED_LOCALES.indexOf(normalizedLocale) < 0) {
    return DEFAULT_LOCALE;
  }
  return normalizedLocale;
};
class LocaleService {
  constructor() {
    this.loadMergedTranslations = this.loadMergedTranslations.bind(this);
    this.loadedLocaleData = loadedLocaleData;
  }

  /**
   * @method
   * @description
   * it provides all the supported locale
   */
  static getAllAllowedLocales() {
    return ALLOWED_LOCALES;
  }
  initialize(locale) {
    this._locale = getFinalLocale(locale);
  }

  /**
   * @method
   * @description
   * provides the current locale
   */
  getLocale() {
    return this._locale;
  }

  /**
   * @method
   * @description
   * it provides the translated locale data merged with our default locale (en-US)
   *
   * @param loc locale
   * @return {Promise} return Promise resolved with locale data
   */
  _loadTranslationsWrapper(loc) {
    return Promise.resolve(_objectSpread(_objectSpread({}, this.loadedLocaleData["en-US"]), this.loadedLocaleData[loc]));
  }

  /**
   * @method
   * @description
   * it provided the final translated locale data merged with the default locale and
   * localisation string that is provided during initialisation or at the time of
   * file preview
   *
   * @param loc locale
   *
   * @return {Promise} return Promise resolved with merged locale data
   */
  loadMergedTranslations(loc) {
    return new Promise((resolve, reject) => {
      const appStore = _ServiceRegistry.default.getService("AppStore");
      this._loadTranslationsWrapper(loc).then(translationFile => {
        const localizationStrings = _objectSpread(_objectSpread({}, appStore.configStore.getConfig().localizationStrings), appStore.configStore.getActionConfig("preview").localizationStrings);
        resolve(_objectSpread(_objectSpread({}, translationFile), localizationStrings));
      }).catch(err => reject(err));
    });
  }
}
exports.default = LocaleService;